import { fetchApi } from 'api/fetchApi'
import { definitions } from 'api/generated/photo'

export const fetchAskPhotoApi = () =>
  fetchApi<definitions['NeedAskForPhoto']>('/needAskForPhoto')
